export default __webpack_public_path__ + "static/media/searchicon.572a8553.svg";